function init_gameninja(from_php){
   var main=$(".place.gameninja");
//    var girl_name=$.takeGirlImage(girl_id);
//    var gameCover=main.find("#gameCover");
//    init_gameninja_game(from_php);
//
//    gameCover.addClass("hide");
//    main.find(".hideOnGameJS").addClass("hide");
//    main.find(".showOnGameJS").removeClass("hide");
//    return false;

    if(typeof from_php.girl_id=="undefined" || from_php.girl_id==0){
        return false;
    }
     var toHide=$("#mainButtonsBar,#mainBeltRightDownCorner,#ic_premium");
    toHide.css("bottom","-100px")
    _moduleEvents.on("moduleClear",function(){
        toHide.removeAttr("style");
    });

    var semaphoreSuit= new mySemaphore();

    var girl_id=intval(from_php.girl_id);

    var timeIndexArr={
        "ajax":_moduleTimeHandler.getNewIndex(),
        "wrong":_moduleTimeHandler.getNewIndex(),
        "timeout":_moduleTimeHandler.getNewIndex(),
        "timeout_error":_moduleTimeHandler.getNewIndex()
    };

    var main=$(".place.gameninja");
    var girl_name=$.takeGirlImage(girl_id);
    var gameCover=main.find("#gameCover");
    var gameCoverState=main.find(".stateJS"),gameCoverWin;
    var state_cur="";
    var gameLog=[];
    var secureStr=from_php.secure;

    function postAjax(to_send,refuse_response,on_end){
        if(semaphoreSuit.use()){
            var data_send={girl_id:girl_id,page:"gameninja"};
            data_send=$.extend(data_send,to_send);
            $.mypost('/ajax',data_send, function(res) {
                var data=handleAjaxRes(res),was_clear=0;
                if(typeof data!="undefined" && data){
                    if(intval(data.level_show)>intval(from_php.level_show)){
                        _mySound.playSound("girl_smile");
                    }
                    if(intval(data.was_ended)>intval(from_php.was_ended)){
                        _mySound.playSound("girl_moan");

                        _moduleTimeHandler.setOne(_moduleTimeHandler.getNewIndex(),function () {
                          $.goToLocation("orgy");
                        },2500);
                        return false;
                    }
                    from_php=$.extend(from_php,data);
                    function isEnd(){
                        if(!refuse_response){
                            updateState();
                        }
                        if(typeof on_end=="function"){
                            on_end();
                        }
                    }
                    if(data_send.wait){
                        _moduleTimeHandler.setOne(timeIndexArr.ajax,function(){
                            isEnd();
                        },data_send.wait);
                    }
                    else{
                        isEnd();
                    }

                }
                semaphoreSuit.clear();
            },"json");
        }
    }

    function updateState(){

        if(from_php.was_error){
            showState("wrong");
        }
        else if(from_php.time_game){
            showState("game");
        }
        else{
            if(from_php.was_paid==0){
                if(from_php.try_count>0){
                    showState("init");
                }
                else{
                    showState("need_try");
                }
            }
            else if(from_php.was_shown==0){
                showState("next");
            }
            else{
                showState("game_init");
            }
        }
        main.attr("data-level",(intval(from_php.level_show)+1))
    }


    function init(){
        main.find(".butNextLevelStartJS").click(function(){
            _mySound.playSound("button_click");
            postAjax({prepare_init:1});


        });
        main.find(".buyGirlDateJS").click(function(){
            _mySound.playSound("button_click");
            var th=$(this),premium_count=intval(th.attr("data-need"));
            $.payByPremium(premium_count,function(){
                postAjax({buy_date:1});
            });
        });
        main.find(".repeatMoveTriggerJS").click(function(){
            _mySound.playSound("button_click");
           var th=$(this),premium_count=intval(th.attr("data-need"));
           postAjax({buy_repeat:1});
        });

        var state_game={lives:3},semaphoreEvent= new mySemaphore();;
        var gameCanvas=main.find("#girlGameJsCanvas");
        function getLive(howmany,reason_id){
            state_game.lives-=howmany;
            if(state_game.lives<=0){
                gameLog=[];
                gameCanvas.off();
                _mySound.playSound("bunny_win");
                postAjax({was_error:reason_id});
                return false;
            }
            return true;
        }
        gameCanvas.on("collisionEvent boss_killed moveEnd",function(){
            if(semaphoreEvent.use()){

                while(gameLog.length){
                    var data=gameLog.splice(0,1);
                    data=data[0];

                    if(data.event=="collisionEvent"){
                        if(data.eventType=="chick"){
                            if(!getLive(1,1)){
                                break;
                            }
                        }
                    }
                    else if(data.event=="boss_killed"){
                        if(state_game.lives>0){
                            _moduleTimeHandler.addOne(function(){
                                postAjax({game_conf:(Base64.encode(secureStr))});
                            },2000);
                        }
                        gameCanvas.off();
                        gameLog=[];
                        break;
                    }
                    else if(data.event=="moveEnd"){
                        if(data.eventType=="egg"){
                            if(!getLive(1,2)){
                                break;
                            }
                        }
                        if(data.eventType=="boss"){
                            if(!getLive(3,3)){
                                break;
                            }
                        }
                    }
                }

                semaphoreEvent.clear();
            }
        });

        _moduleEvents.one("game_was_init",function(){
            gameCanvas.startGirlAnim("setEventLog",gameLog);
        });
        _moduleEvents.on("game_run",function(){
            postAjax({start_game:1});
        });
//        _moduleEvents.one("game_fail",function(reason_id){
//            _moduleEvents.off("game_ready");
//            _mySound.playSound("bunny_win");
//            postAjax({was_error:reason_id});
//        });
//        _moduleEvents.on("game_ready",function(){
//            _moduleEvents.off("game_fail");
//            _moduleTimeHandler.addOne(function(){
//                postAjax({game_conf:(Base64.encode(from_php.secure))});
//            },2000);
//        });



        updateState();
    }


    var stateIndex={
        "game":[_moduleTimeHandler.getNewIndex()]
    };
    var stateFun={
        "wrong":function(){
            if(from_php.level_show>3){
                main.find(".repeatMoveJS").show();
            }
            else{
                main.find(".repeatMoveJS").hide();
            }
            main.find("#failReasonJS").html(from_php.langs["fail"+from_php.was_error]);
        },
        "init":function(){
          postAjax({prepare_init:1});

        },
        "need_try":function(){

        },
        "next":function(){
            main.find(".putGameJs[data-type='level']").html(intval(from_php.level_show)+1);
            var levelShow = main.find(".levelRow>span:nth-child(2)");
            if(intval(levelShow.html())==0) {
                levelShow.css("font-size","55px");
            }
        },
        "game":function(){
          var gameObj;

          gameObj=new ninjaGameEaster(main.find("#girlGhostJsCanvas"),from_php.game_conf,{
              isTest:0,
              onLoad:function(){
                main.one("myPreloaderInit",function(){}).one("myPreloaderEnd",function(){
                  gameObj.start();
                }).myPreloader({urlArr:[
                        _IMG_SERV+"/gfx/place/gameninja/easter/back/rabbit_action.jpg",
                        _IMG_SERV+"/gfx/place/gameninja/easter/back/rabbit_wait.jpg"
                ],addToLoader:0},_moduleTimeHandler);
              },
              onLose:function(obj){
                  //{val: 11, reason_id: 2}
                  _mySound.stopSound("hall_cat_claws");

                  postAjax({was_error:obj.reason_id});
              },
              onWin:function(obj){
                  //{val: 20}
                  var wait=1000;
                  if(typeof obj.wait!="undefined"){
                      wait=obj.wait;
                  }
                  _mySound.stopSound("hall_cat_claws");
                  postAjax({
                     game_conf:(Base64.encode(secureStr)),
                     wait:wait
                  });
              }
          });

            // ninjaGameEaster(main.find("#girlGhostJsCanvas"),from_php.game_conf);
            main.find("#bookGameJS").bookUse("hide");
            gameCover.addClass("hide");
            main.find(".showOnGameJS").removeClass("hide");
            main.find(".hideOnGameJS").addClass("hide");
        },
        "game_init":function(){
            var canvasPos=[444,250];//jsquery bug workaround;
            var helpPos=[444,210];
            var gameNinja;
            var confBad={
                anim_type:"img",
                img:"egg1",
                map_name:"egg_big",
                step_max:0,
                scale_arr:[100,100],
                pos_start:[canvasPos[0],canvasPos[1]],
                onCut:function(obj){
                  _mySound.playSound("game_cut_good_word");
                  var angle_die=mt_rand(0,359);

                   var pos=obj.cut_data.pos;
                   //var scale=100;//obj.cut_data.scale
                  var qobj=this.addViewObj(myPixiObj.drawCustom,[{
                      spine_conf:{
                          spineResource:gameNinja.takeSpineResources(),
                          onAnimComplete:function(){
                              qobj.step_max=1;
                          }
                      },
                      anim_type:"spine",
                      img:"eggs",
                      scale_arr:[100,100],
                      rotation_arr:[obj.cut_data.angle],
                      step_max:0,
                      dir:obj.cut_data.dir,
                      v:3,
                      pos_start:pos,pos_end:pos
                  }]);
                }
            };


            main.find("#bookGameJS").bookUse("show");

            gameNinja= new cutGame(main.find("#bookGameStartJS"),{
                width:609,
                height:410,
                imagesPreloader:{
                    "puffb":_IMG_SERV+"/gfx/place/girls/ninja/puffblack.png",
                     egg1:_IMG_SERV+"/gfx/place/gameninja/cutimages/egg_big.png",
                     pumpkin_die:"/gfx/place/gameninja/halloween/pumpin/die/ready.png",
                },
                spinePreloader:{
                    help:_IMG_SERV+"/gfx/place/girls/gamebook/spine_help/skeleton.json",
                    eggs: _IMG_SERV+"/gfx/place/gameninja/cutimages/eggs/spine/skeleton.json",
                },
                onLoad:function(){
                    gameNinja.start();

                    var helpObj=gameNinja.addFrontObj(myPixiObj.drawCustom,[{
                        spine_conf:{
                            anim_loop:true,
                            spineResource:gameNinja.takeSpineResources()
                        },
                        anim_type:"spine",
                        step_max:0,
                        img:"help",pos_start:helpPos,pos_end:helpPos,scale_arr:[80,80]
                    }]);
                    _moduleEvents.on("cutGameEvent.init",function(){
                        var log_arr=gameNinja.getLogs();
                        var i,bum,data_cut;
                        for(i in log_arr){
                            bum=log_arr[i];
                            data_cut=bum.cut_data;

                            if(data_cut.type=="egg" || data_cut.type=="bat2"){
                                _mySound.playSound("game_cut_good_word");
                                _moduleEvents.off("cutGameEvent.init");
                                helpObj.step_max=1;
                                postAjax({
                                    start_game:1,wait:600
                                },0,function(){
                                  gameNinja.remove();
                                });
                                break;
                            }
                        }

                    });
                    gameNinja.addCollisionCustom("egg",confBad);

                }
            });
        }
    };
    function showState(state){
        main.find(".putGameJs[data-type='try']").html(from_php.try_count);
        main.find(".arrSetCountJS").attr("data-count",from_php.try_count);
        _timerManager.addTimer(".place.gameninja .timerKeyWaitJS",from_php.try_time,1);
        _moduleTimeHandler.clear(timeIndexArr.timeout);

        if(state!="game"){
            main.find(".hideOnGameJS").removeClass("hide");
            main.find(".showOnGameJS").addClass("hide");
            gameCover.removeClass("hide");
        }


        state_cur=state;

        gameCoverWin=gameCoverState.addClass("hide").filter("[data-state='"+state+"']").removeClass("hide");
        if(typeof stateFun[state]=="undefined"){
            alert(state+"!");
        }
        stateFun[state]();
    }

    var rabbitState=0;
    function rabbitAnim(){
        var conf={
            "0":{clips:9},
            "1":{clips:11}
        };
        var rabbitIndex=_moduleTimeHandler.getNewIndex();
        var rabbitObj=main.find("#rabbitBox");
        function newAnim(){
            var qState=Math.min(rabbitState,1);
            var i=-1,i_max=conf[qState].clips,interval=50;
            rabbitObj.css("background-position","0px 0px").attr("data-state",qState);
            _moduleTimeHandler.set(rabbitIndex,function(){
                i++;
                rabbitObj.css("background-position",(-i*576)+"px 0px");
                if(i>=i_max-1){
                    _moduleTimeHandler.clear(rabbitIndex);
                    _moduleTimeHandler.setOne(interval,function(){
                        newAnim();
                    },interval);
                }
            },interval);
            rabbitState=Math.max(0,rabbitState-1);
        }
        newAnim();
    }
    _moduleEvents.on("addEgg",function(){
        rabbitState++;
    });
    rabbitAnim();


    init();
}
